(window as any).PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAuhV1Km8H04J+YDuCfjZT
rEPe9VgFEa4K4IkUCZKZAsBy2ydiejlHJuqqJJy204tQ6YABnVxh9wotIzFUSh5J
pITyCp73R0/5Sbu6F6AmDQwpREx7Qz49sTXq7VqB9idE4QqUPgmXHn5nCcIqepmx
c2HLZfEr2SeR3oC0pOkvCrozDY08EqNKLxAYKp7ZYOvlIoak2S00bdTAVQQSJ0Ty
xv/REHIuKoeOpQsWmrvCT9zewqG6ujWFD1LN+XQ2Mu5oVS2znvHmZzALC9bWgCA6
ebeveXjyHM/c8dmb7bSaXNtHqYwN2W2wSEimi8fg176DAJmXA8+BZj38MFvacIdj
zQIDAQAB
-----END PUBLIC KEY-----`;

export {};